import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { DisplayText } from '../../../display-text/display-text';
import { Icon } from '../../../icon';
export var RadioInputSize;
(function (RadioInputSize) {
    RadioInputSize["Normal"] = "Normal";
    RadioInputSize["Large"] = "Large";
})(RadioInputSize || (RadioInputSize = {}));
const b = bemClassBuilder('v-radio-input');
const defaultSelectedIconName = 'bullet-point';
/**
 * Renders a single radio input.
 * Note: You're unlikely to use this component directly. Instead, use the RadioGroup component.
 */
export const RadioInput = observer(props => {
    const { className, label, labelClassName, name, optionValue, value: checked, onChange, onChangeValue, style, disabled, selectedIconName, id, size } = props;
    const [isFocused, setIsFocused] = useState(false);
    const handleChange = event => {
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
        onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(event.target.checked);
    };
    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);
    const hasCustomIcon = selectedIconName !== undefined &&
        selectedIconName !== '' &&
        selectedIconName.localeCompare(defaultSelectedIconName) !== 0;
    return (_jsx("div", Object.assign({ className: b.block({ disabled, style: style }, className), id: id }, { children: _jsxs("label", Object.assign({ className: b.element('label', { disabled }, labelClassName) }, { children: [_jsx("input", { className: b.element('input'), type: "radio", value: optionValue, name: name, onChange: handleChange, checked: checked, onFocus: handleFocus, onBlur: handleBlur, disabled: disabled }), _jsx("div", Object.assign({ className: b.element('button', {
                        focused: isFocused,
                        checked,
                        size
                    }) }, { children: _jsx(Icon, { name: selectedIconName || defaultSelectedIconName, className: b.element('icon', {
                            customIcon: hasCustomIcon,
                            size
                        }) }) })), _jsx(DisplayText, { label: label }), props.children] })) })));
});
RadioInput.displayName = 'RadioInput';
